module.exports = __webpack_public_path__ + "img/tour-62.5aa64877.png";